

export const types={
    login:  '[Auth] Login',
    logout: '[Auth] Logout',

    uiSetError:     '[UI] Set Error',
    uiRemoveError:  '[UI] Remove Error',

    uiStartLoading:  '[UI] Start loading',
    uiFinishLoading: '[UI] Finish loading',

    notesAddNew:            '[Notes] New note',
    notesActive:            '[Notes] Set Active note',
    notesLoad:              '[Notes] Load notes',
    notesUpdated:           '[Notes] Update note',
    notesFileUrl:           '[Notes] Update image url',
    notesDelete:            '[Notes] Deleted note',
    notesLogoutCleaning:    '[Notes] Logout Cleaning',

} 